import APIServices from '@/apiUtils/APIServices';
import countries from '@/helpers/countries';
import { CountryCodeSelector } from '@/helpers/CountryCodeSelector';
import useWidth from '@/helpers/widthUtil';
import { Button, Col, Input, Select } from 'antd';
import Link from 'next/link';
import React, { useContext, useEffect, useState } from 'react';
import { Collapse } from 'reactstrap';
import { AbroadContext } from '.';

const EnquiryForm = () => {
  const { isMobile } = useWidth();
  const [error, setError] = useState<any>({});
  const [dropDownData, setDropDownData] = useState<any>({});
  const { formData, setFormData, processSendMessage } = useContext(AbroadContext);

  useEffect(() => {
    fetchDropdownData();
    setError({});
  }, []);

  const fetchDropdownData = async () => {
    const dta = {};

    const degreeLevels = await new APIServices('drop_down/degree-level/').getSic();
    if (degreeLevels?.success) dta['degreeLevels'] = degreeLevels?.data?.data;

    const categories = await new APIServices('drop_down/category/').getSic();
    if (categories?.success) dta['categories'] = categories?.data?.data;

    const preffered_countries = await new APIServices(
      'drop_down/preferred-countrylist/'
    ).getSic();
    if (preffered_countries?.success)
      dta['preffered_countries'] = preffered_countries?.data?.data;

    const countries = await new APIServices('country-dropdown/').getSic();
    if (countries?.success) dta['countries'] = countries?.data?.data;

    const englishTests = await new APIServices('drop_down/english-test/').getSic();
    if (englishTests?.success) dta['englishTests'] = englishTests?.data?.data;

    // if (institute) {
    //   const intakes = await new APIServices(
    //     `drop_down/institute/intake/?institute_id=${institute}`
    //   ).get();
    //   if (intakes?.success) dta['intakes'] = intakes?.data?.data;
    // }
    setDropDownData(dta);
  };

  const onChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;

    if (id === 'phone') {
      value.slice(0, 10).toString().length >= 10
        ? setError({ ...error, phone: '' })
        : '';
    }
    if (id === 'country_code') {
      setFormData({ ...formData, [id]: `+${value}` });
    } else setFormData({ ...formData, [id]: value });
  };

  const handleSelect = (id, value) => {
    setFormData({ ...formData, [id]: value });
  };

  const submitEnquiryForm = (e) => {
    e.preventDefault();
    const form = e.target;
    let isValid = true;
    let data = {};
    Array.from(form.elements).forEach((a: any) => {
      if (a.checkValidity()) {
        if (!!a.id && !a.id.includes('unusedId') && a.value !== '') {
          data[a.id] = a.value;
        }
      } else isValid = false;
    });
    if (formData?.phone?.toString().length < 10) {
      setError({ ...error, phone: 'Phone number should be 10 digit number.' });
      isValid = false;
    }
    if (formData?.email) {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(formData?.email)) {
        isValid = false;
        setError({ ...error, email: 'Please enter valid email address.' });
      }
    }
    if (!!isValid) {
      processSendMessage();
      // setIsOtpFormVisible(true);
    }
  };

  return (
    <form onSubmit={submitEnquiryForm} id="enquiryForm">
      <div className="row mt-4">
        <div className="col-lg-6">
          <CustomInput
            type="text"
            id="first_name"
            onChange={onChange}
            placeholder="First Name"
            value={formData?.first_name || ''}
            required
            error={error?.first_name}
          />
        </div>
        <div className="col-lg-6">
          <CustomInput
            id="last_name"
            type="text"
            onChange={onChange}
            placeholder="Last Name"
            value={formData?.last_name || ''}
            required
            error={error?.last_name}
          />
        </div>
        <div className="col-lg-6">
          <CustomInput
            id="email"
            type="email"
            onChange={onChange}
            placeholder="Email"
            value={formData?.email || ''}
            required
            error={error?.email}
          />
        </div>
        <div className="col-lg-6">
          <div className="row mt-1">
            <div className={`${isMobile ? 'col-4' : 'col-md-5 col-lg-5 col-sm-5'}`}>
              <div className="form-group country-code-selector">
                <label className="text-left ml-1 font-weight-bold">Code</label>
                <CountryCodeSelector
                  onChange={(val) => handleSelect('country_code', val)}
                  defaultValue={formData?.country_code || '+977'}
                />
              </div>

              {error?.country_code && (
                <span className="validation mb-2">
                  <i className="fas fa-exclamation-triangle"></i>{' '}
                  {error?.country_code}
                </span>
              )}
            </div>
            <div
              className={`${isMobile ? 'col-8' : 'col-md-7 col-lg-7 col-sm-7 pl-0'}`}
            >
              <CustomInput
                id="phone"
                type="number"
                onChange={onChange}
                placeholder="Phone Number"
                value={formData?.phone || ''}
                required
                error={error?.phone}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <CustomSelect
            id="country"
            onChange={(val) => handleSelect('country', val)}
            placeholder="Country"
            value={formData?.country || ''}
            required
            error={error?.country}
            showSearch
            options={Object.entries(countries)?.map((each, idx) => ({
              key: each[1],
              value: each[1],
            }))}
          />
        </div>

        <div className="col-lg-6">
          <CustomInput
            id="city"
            type="text"
            onChange={onChange}
            placeholder="City"
            value={formData?.city || ''}
            required
            error={error?.city}
          />
        </div>

        <div className="col-lg-12">
          <div className="form-group">
            <label className="font-weight-bold">
              Message <span className="text-danger">*</span>
            </label>
            <textarea
              id="message"
              value={formData?.message || ''}
              className="form-control w-100 border-14 text-bold"
              placeholder="Your Message"
              onChange={onChange}
              required
              style={{ border: '1px solid #d9d9d9' }}
              rows={3}
            ></textarea>
          </div>
        </div>
      </div>

      <CollapsableWrapper title="Educational Details">
        <div className="col-lg-12">
          <CustomSelect
            id="degree_level"
            onChange={(val) => handleSelect('degree_level', val)}
            placeholder="Degree Level"
            value={formData?.degree_level || ''}
            error={error?.degree_level}
            showSearch
            options={dropDownData?.degreeLevels?.map(({ id, name }) => ({
              key: id,
              value: name,
            }))}
          />
        </div>

        <div className="col-lg-12">
          <CustomSelect
            id="category"
            onChange={(val) => handleSelect('category', val)}
            placeholder="Course Category"
            value={formData?.category || ''}
            error={error?.category}
            showSearch
            options={dropDownData?.categories?.map(({ id, name }) => ({
              key: id,
              value: name,
            }))}
          />
        </div>

        <div className="col-lg-6">
          <CustomInput
            id="academic_score"
            type="number"
            onChange={onChange}
            placeholder="Academic Score"
            value={formData?.academic_score || ''}
            error={error?.academic_score}
          />
        </div>

        <div className="col-lg-6">
          <CustomSelect
            id="score_type"
            onChange={(val) => handleSelect('score_type', val)}
            placeholder="Score Type"
            value={formData?.score_type || ''}
            error={error?.score_type}
            showSearch
            options={[
              { key: 0, value: 'Percentage' },
              { key: 1, value: 'GPA' },
            ]}
          />
        </div>

        <div className="col-lg-6">
          <CustomSelect
            id="english_test"
            onChange={(val) => handleSelect('english_test', val)}
            placeholder="English Test"
            value={formData?.english_test || ''}
            error={error?.english_test}
            showSearch
            options={dropDownData?.englishTests?.map(({ name }) => ({
              key: name,
              value: name,
            }))}
          />
        </div>

        <div className="col-lg-6">
          <CustomInput
            id="overall_score"
            type="number"
            onChange={onChange}
            placeholder="Overall Score"
            value={formData?.overall_score || ''}
            error={error?.overall_score}
          />
        </div>
      </CollapsableWrapper>

      <CollapsableWrapper title="Other Details">
        <div className="col-lg-12">
          <CustomSelect
            id="nationality"
            onChange={(val) => handleSelect('nationality', val)}
            placeholder="Nationality"
            value={formData?.nationality || ''}
            error={error?.nationality}
            showSearch
            options={dropDownData?.countries?.map(({ name }) => ({
              key: name,
              value: name,
            }))}
          />
        </div>

        <div className="col-lg-6">
          <CustomSelect
            id="preferred_country"
            onChange={(val) => handleSelect('preferred_country', val)}
            placeholder="Preferred Country"
            value={formData?.preferred_country || ''}
            error={error?.preferred_country}
            showSearch
            options={dropDownData?.preffered_countries?.map(({ name }) => ({
              key: name,
              value: name,
            }))}
          />
        </div>

        <div className="col-lg-6">
          <CustomSelect
            id="preferred_intake"
            onChange={(val) => handleSelect('preferred_intake', val)}
            placeholder="Preferred Intake"
            value={formData?.preferred_intake || ''}
            error={error?.preferred_intake}
            showSearch
            options={
              dropDownData?.intakes?.map(({ id, month }) => ({
                key: id,
                value: month,
              })) || [
                { key: 2023, value: 2023 },
                { key: 2024, value: 2024 },
                { key: 2025, value: 2025 },
                { key: 2026, value: 2026 },
                { key: 2027, value: 2027 },
              ]
            }
          />
        </div>
      </CollapsableWrapper>

      <Col md={12}>
        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="termsnconditions"
              required
              // value={isChecked}
              // onChange={(e) => setIsChecked(e.target.checked)}
            />
            <label className="custom-control-label" htmlFor="termsnconditions">
              I Accept &nbsp;
              <Link href="/terms-conditions" prefetch={false}>
                <a className="text-primary">Terms And Conditions</a>
              </Link>
            </label>
          </div>
        </div>
      </Col>
      <Button
        htmlType="submit"
        size="large"
        className="text-white btn-block mt-2 mb-2 border-14 bg-primary"
      >
        Send Message
      </Button>
    </form>
  );
};

export default EnquiryForm;

export const CustomInput = ({ error, placeholder, required, ...rest }: any) => (
  <>
    <div className="form-group">
      <label className="font-weight-bold">
        {placeholder} {required ? <span className="text-danger">*</span> : ''}
      </label>
      <Input className="border-14" size="large" required={required} {...rest} />
    </div>
    {error && (
      <span className="validation mb-2">
        <i className="fas fa-exclamation-triangle"></i> {error || ''}
      </span>
    )}
  </>
);

export const CustomSelect = ({
  id,
  label,
  handleSelect,
  formData,
  error,
  placeholder,
  options,
  required,
  value,
  ...rest
}: any) => (
  <>
    <div className="form-group">
      <label className="font-weight-bold">
        {placeholder}
        {required ? <span className="text-danger">*</span> : ''}
      </label>
      <input id={id} value={value} type="hidden" required={required} />
      <Select
        style={{ width: '100%' }}
        className="border-14"
        optionFilterProp="children"
        onChange={(val) => handleSelect(id, val)}
        size="large"
        required={required}
        value={value || ''}
        {...rest}
      >
        {!!options?.length
          ? options?.map(({ key, value }) => (
              <Select.Option key={`dropdown-${key}-${value}`} value={key}>
                {value}
              </Select.Option>
            ))
          : null}
      </Select>
    </div>
    {error && (
      <span className="validation mb-2">
        <i className="fas fa-exclamation-triangle"></i> {error || ''}
      </span>
    )}
  </>
);

export const CollapsableWrapper = ({ title, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <>
      <div
        onClick={() => setIsCollapsed(!isCollapsed)}
        className={`collapser position-relative cursor-pointer text-${
          isCollapsed ? 'primary' : 'dark'
        }`}
      >
        <div className="card-header mb-4 ">
          <div className="widget-title text-primary">{title}</div>
        </div>
      </div>
      <Collapse isOpen={!isCollapsed} className="p-0 row">
        {children}
      </Collapse>
    </>
  );
};
